<template>
<v-card-actions class="pa-0 ma-0" style="width:300px;">
<!--  {{processingSample}}-->
<!--  {{failedSample}}-->
  <div style="width:260px;">
    <v-card-actions v-if="isErrorState" class="pa-0 ma-0">
      <div style="width:130px; overflow:hidden">
            <v-btn  color="error" @click="releaseSample()" tile small block>Err. Try Again</v-btn>
      </div>
      <v-divider vertical></v-divider>
      <div style="width:130px; overflow:hidden">
           <v-btn color="orange darken-2" @click="$store.dispatch('ReleaseSampleStore/deleteQueuedSample', sample.uuid)" tile small block>Reset</v-btn>
      </div>
    </v-card-actions>
<!--    <span v-if="processingSample">{{processingSample.process_status.updated_at}}</span>-->
    <v-btn v-if="!sample.is_released && !failedSample && !processingSample && (!sample.amended_notes || sample.amended_notes.length === 0)" @click="releaseSample()" color="success" tile small block>Release</v-btn>
    <v-btn v-else-if="(doneSample || sample.is_released) && !failedSample && !processingSample" @click="releaseSample()" color="primary" tile small block>Re-Release</v-btn>
    <Confirm
        v-else-if="!sample.is_released && !failedSample && !processingSample && (sample.amended_notes && sample.amended_notes.length > 0 && sample.amended_notes.some(note => !note.released))"
        @confirmed="releaseSample"
        message="Please make sure to download the current cert and store in the appropriate place before amending."
        confirm_text="I have downloaded the cert, amend the sample."
        max_width="600"
    >
      <template v-slot:activator="{on}">
        <v-btn color="orange darken-2 white--text" v-on="on" small tile :disabled="$store.state.testing">Amend</v-btn>
      </template>
      <template v-slot:inner_upper>
        <v-card-actions><v-btn @click="getCert" :loading="loading_cert" :disabled="loading_cert" small block>Open cert</v-btn></v-card-actions>
        <v-divider></v-divider>
      </template>
    </Confirm>
<!--    <v-btn v-else-if="!sample.is_released && !failedSample && !processingSample" @click="releaseSample()" color="orange" tile small block>Amend</v-btn>-->
    <v-btn v-else-if="failedSample" @click="releaseSample()" tile small block>{{failedSample.process_status.message}}</v-btn>
    <v-btn v-else class="text-left" tile small block>{{processingSample.process_status.message in messages ? messages[processingSample.process_status.message] : processingSample.process_status.message}}</v-btn>
  </div>
  <v-btn
      v-if="!doneSample && !sample.is_released && (!sample.amended_notes || sample.amended_notes.length === 0) && !failedSample && !processingSample"
         class="error"
      icon
      @click="markAsReleased"
      small
      tile
      dark>
    <v-icon>mdi-close</v-icon>
  </v-btn>
</v-card-actions>
</template>

<script>
import firebase from "firebase";
import "firebase/functions";
export default {
  name: "ReleaseSampleV2",
  props: {
    sample: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    messages: {
      getSampleId: "1/9 Getting Sample ID",
      DerivedAnalytes: "2/9 Getting Derived Analytes",
      getSampleData: "3/9 Getting Sample Data",
      getCustomerData: "4/9 Getting Customer Data",
      formatSampleData: "5/9 Formatting Sample Data",
      sendToReported: "6/9 Sending to Results",
      markAsReleased: "7/9 Marking Sample as Released",
      callCertQueue: "8/9 Calling Cert Queue",
      waitingForCertGeneration: "9/9 Waiting for Cert",
    },
    interval: null,
    minutesSinceLastUpdate: 0,
    isErrorState: false,
    loading_cert: false,
  }),
  computed: {
    processingSample(){
      return this.sample.uuid in this.$store.state.ReleaseSampleStore.samplesProcessing ? this.$store.state.ReleaseSampleStore.samplesProcessing[this.sample.uuid] : false;
    },
    failedSample(){
      return this.sample.uuid in this.$store.state.ReleaseSampleStore.samplesFailed ? this.$store.state.ReleaseSampleStore.samplesFailed[this.sample.uuid] : false;
    },
    doneSample(){
      return this.sample.uuid in this.$store.state.ReleaseSampleStore.samplesProcessed ? this.$store.state.ReleaseSampleStore.samplesProcessed[this.sample.uuid] : false;
    },

  },
  watch: {
    processingSample(v){
      if(v && !this.interval){
        this.interval = setInterval(() => {
          this.minutesSinceLastUpdate = this.$moment().diff(this.$moment(v.process_status.updated_at.toDate()), 'minutes');
          if(this.minutesSinceLastUpdate > 0){
            this.isErrorState = true;
            clearInterval(this.interval);
            this.interval = null;
          }
        }, 1000);
      }else{
        if(this.interval){
          clearInterval(this.interval);
          this.interval = null;
        }
        this.isErrorState = false;
      }
    },
    doneSample(v){
      if(v){
        this.sample.is_released = true;

      }
    }
  },
  mounted() {
    if(this.processingSample){
      this.minutesSinceLastUpdate = this.$moment().diff(this.$moment(this.processingSample.process_status.updated_at.toDate()), 'minutes');
      if(this.minutesSinceLastUpdate > 0){
        this.isErrorState = true;
      }
    }
  },
  methods: {
    releaseSample(){
      this.isErrorState = false;
      // if(this.processingSample) return;
      // this.$firestore.collection('release_sample').doc(this.sample.uuid).set({
      //   cert_generated: false,
      //   is_ready: false,
      //   is_ready_v2: true,
      //   sample_uuid: this.sample.uuid,
      //   process_status: {
      //     state: 'processing',
      //     message: 'Queueing for release',
      //   }
      // })
      // this.generateReleaseAttemptLog()
      this.$store.dispatch('ReleaseSampleStore/releaseSample', this.sample.uuid)
    },
    async generateReleaseAttemptLog(type = "Release"){
      let message = "Release Attempted";
      if(type === "amendment"){
        message = "Amendment Release Attempted";
      }
      await this.$firestore.collection('conan_logs').doc().set({
        uuid: this.sample.uuid,
        action: "RELEASE",
        timestamp: this.$moment().utc().format("YYYY-MM-DD HH:mm:ss"),
        model: "sample",
        request_type: "Firestore update: release_sample",
        request_uri: "Firestore Release Queue",
        diff: {
          display_text: message,
          from_display_text: null,
          from_value: null,
          key: null,
          value: null
        },
        location: window.location.href,
        user_id: this.$store.getters.id,
        user_name: this.$store.getters.name,
      });
    },
    async markAsReleased(){
      this.sample.is_released = true;
      this.$store.$db().model('samples').api().save({
        uuid: this.sample.uuid,
        id: this.sample.id,
        is_released: true,
        updated_by: this.$store.getters.id
      })
    },
    amendSample(){},
    async getCert(){
      this.loading_cert = true;
      let links =  firebase.functions().httpsCallable('reportedCertLinks');
      links = await links({sample_id: this.sample.id});
      window.open(links.data.full, '_blank');
      this.loading_cert = false;
    }

  }
}
</script>

<style scoped>

</style>
